/**
 * Route copy for `src/routes/growth` (keys: `routes.growth.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  programsPage: {
    partnerPrograms: 'Partner programs',
  },
};

export default en;
